export default {"src":"/_next/static/image/public/images/img-addfamilymember.80a9c8b3947d585c8cf085ca0ef74b14.svg","height":161,"width":153};